import React from "react";

function ProfileOverview() {
  return (
    <div>
      <h1>Overview</h1>
    </div>
  );
}

export default ProfileOverview;